import { Component, Inject, OnInit } from '@angular/core';
import { BcFormComponent } from '../../bc-form/bc-form.component';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { BcComponentsService } from '../../bc-components.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { EmailFournisseurDTO } from 'src/app/shared/dtos/EmailFournisseurDTO';
import { BcService } from 'src/app/shared/services/bc/bc.service';
import { FournisseurService } from 'src/app/shared/services/societe-linked/fournisseur.service';
import { FournisseurModel } from 'src/app/shared/models/societe-linked/fournisseur.model';
import { PdfService } from 'src/app/shared/services/pdf.service';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { SiteService } from 'src/app/shared/services/societe-linked/site.service';
import { SiteModel } from 'src/app/shared/models/societe-linked/site.model';
import { DefinitionTypeBC } from 'src/app/shared/typeBCDefinitions';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface DialogData {
  bcForm: UntypedFormGroup
}

@Component({
  selector: 'app-modal-formulaire-email',
  templateUrl: './modal-formulaire-email.component.html',
  styleUrls: ['./modal-formulaire-email.component.scss']
})

export class ModalFormulaireEmailComponent implements OnInit {
  bcForm: UntypedFormGroup;
  formulaireForm: UntypedFormGroup = new UntypedFormGroup({});
  emailControl: UntypedFormControl;
  objetMailControl: UntypedFormControl;
  corpsMailControl: UntypedFormControl;
  objetMail: string;
  corpsMail: string;
  titre: string = "";
  libelle: string = "";
  siren: string = "";

  constructor(public dialog: MatDialog,  
               public router: Router,
               private pdfService: PdfService,
               public dialogRef: MatDialogRef<Component>,
               private sessionService: SessionService,
               private fournService: FournisseurService,
               private datepipe: DatePipe,
               private bcService: BcService,
               private toastrService: ToastrService,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private siteService: SiteService,
              private societeService: SocieteService
            ) {
                
              }

  ngOnInit(): void {
    this.bcForm = this.data.bcForm;

    // Construction de l'Objet le coprs du mail
    if(this.bcForm.controls.type.value === DefinitionTypeBC.BCEnveloppe){
      this.titre = "Notification de “Commande enveloppe”";
      this.libelle = "Email du fournisseur à saisir en caractères minuscules seulement";
      this.objetMail = "Notification de commande enveloppe n° " + this.bcForm.controls.code.value;
    } else {
      if(this.bcForm.controls.ht.value < 0){
        this.titre = "Envoi d'une demande d’avoir";
        this.libelle = "Email du fournisseur à saisir";
        this.objetMail = "Demande d’avoir n° " + this.bcForm.controls.code.value + " Ref : " + this.bcForm.controls.refFourn.value;
      }else{
        this.titre = "Envoi d'un bon de commande";
        this.libelle = "Email du fournisseur à saisir";
        this.objetMail = "Confirmation de la commande n° " + this.bcForm.controls.code.value;
      }
      
    }
    // ajouter une reference si elle existe
    /*if(this.bcForm.controls.refFourn?.value){
      this.objetMail += " Ref : " + this.bcForm.controls.refFourn.value;
    } */
    this.corpsMail = ""

    this.emailControl = new UntypedFormControl(null, [Validators.required,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]);
    this.objetMailControl = new UntypedFormControl(this.objetMail, [Validators.required]);
    this.corpsMailControl = new UntypedFormControl( this.corpsMail,[Validators.required]);
           
    this.formulaireForm = new UntypedFormGroup({
      email: this.emailControl,
      objetMail: this.objetMailControl,
      corpsMail: this.corpsMailControl
    });

    const idSociete = this.bcForm.controls.idSociete.value;
    const codeFourn = this.bcForm.controls.codeFourn.value;

    forkJoin({
      societe: this.societeService.get(idSociete).pipe(catchError(() => of(null))),
      fourn: this.fournService.getWithCodeSociete(codeFourn, idSociete).pipe(catchError(() => of(null))) // get email fournisseur from bc 
    }).subscribe(({ societe, fourn }) => {

      this.siren = societe?.siren || '';
 
      const dFinValidFormatted = new Date(this.bcForm.controls.dFinValid.value).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).replace(/\//g, '/');

      const today = new Date().toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).replace(/\//g, '/');

      if(this.bcForm.controls.type.value === DefinitionTypeBC.BCEnveloppe){
        // type BC Enveloppe
        this.siteService.getFromCodeAndSociete(this.bcForm.controls.codeSite.value, this.bcForm.controls.idSociete.value).subscribe((site: SiteModel) => {        
          this.formulaireForm.controls.corpsMail.setValue(
          "Madame, Monsieur, \n\nVous trouverez ci-dessous un numéro de commande valable jusqu'au " + dFinValidFormatted + "\n\n" +
          this.bcForm.controls.code.value + "\n\n" +
          "Merci d'indiquer ce numéro de commande sur les factures à émettre et pour toute correspondance concernant la prestation suivante : \n\n" +
          "DESCRIPTION : \n" + this.bcForm.controls.libelle.value + "\n\n" +
          "Pour les fournisseurs assujettis à la réforme de facturation électronique, les factures doivent être adressés à l’identifiant d'adressage : " + this.siren + " aux formats Factur-X, UBL ou CII.\n" +
          "Pour être considérées comme recevables, les factures émises par le Prestataire devront obligatoirement comporter le ou les numéros de Bon de Commande.\n\n" +
          "Vous trouverez ci-dessous les directives et mentions obligatoires de facturation :\n\n" +
          "1 facture par PDF et 1 facture par mail à envoyer à l'adresse électronique suivante : \n" + site.email  + "\n\n" +
          "Mentions obligatoires à figurer sur la facture : votre Dénomination sociale, Adresse, Siret et N° tva intracommunautaire.\n" +
          "Numéro de facture, Date de facture, Numéro de commande, Désignation et décompte des produits et services rendus, Devise (celle de la commande), Montants : HT+TVA = TTC et taux de TVA\n\n" +
          "Libeller la facture à l'entité et l'adresse de facturation spécifiées sur la commande.\n\n" +
          "En cas de cession de facture, merci d'indiquer impérativement la mention \"cédée\" ainsi que les coordonnées bancaires du factor.\n\n" +
          "Cordialement, \nAssainissement et Maintenance France. "
          );}, 
        error => {
          this.formulaireForm.controls.corpsMail.setValue(
            "Madame, Monsieur, \n\nVous trouverez ci-dessous un numéro de commande valable jusqu'au " + dFinValidFormatted + "\n\n" +
            this.bcForm.controls.code.value + "\n\n" +
            "Merci d'indiquer ce numéro de commande sur les factures à émettre et pour toute correspondance concernant la prestation suivante : \n\n" +
            "DESCRIPTION : \n" + this.bcForm.controls.libelle.value + "\n\n" +
            "Pour les fournisseurs assujettis à la réforme de facturation électronique, les factures doivent être adressés à l’identifiant d'adressage : " + this.siren + " aux formats Factur-X, UBL ou CII.\n" +
            "Pour être considérées comme recevables, les factures émises par le Prestataire devront obligatoirement comporter le ou les numéros de Bon de Commande.\n\n" +
            "Vous trouverez ci-dessous les directives et mentions obligatoires de facturation :\n\n" +
            "1 facture par PDF et 1 facture par mail à envoyer à l'adresse électronique de l'adresse de facturation \n\n" +
            "Mentions obligatoires à figurer sur la facture : votre Dénomination sociale, Adresse, Siret et N° tva intracommunautaire.\n" +
            "Numéro de facture, Date de facture, Numéro de commande, Désignation et décompte des produits et services rendus, Devise (celle de la commande), Montants : HT+TVA = TTC et taux de TVA\n\n" +
            "Libeller la facture à l'entité et l'adresse de facturation spécifiées sur la commande.\n\n" +
            "En cas de cession de facture, merci d'indiquer impérativement la mention \"cédée\" ainsi que les coordonnées bancaires du factor.\n\n" +
            "Cordialement, \nAssainissement et Maintenance France. "
            );
        });
      } else {
        if(this.bcForm.controls.ht.value < 0){
          // type BC Avoir
          this.siteService.getFromCodeAndSociete(this.bcForm.controls.codeSiteLivraison.value, this.bcForm.controls.idSociete.value).subscribe((fournSite: SiteModel) => {        
            this.formulaireForm.controls.email.setValue(fourn.mailInterloc);
            this.formulaireForm.controls.corpsMail.setValue("Madame, Monsieur,"
            + "\n\nVous trouverez en pièce jointe une demande d'avoir n° " + this.bcForm.controls.code.value + " concernant " + this.bcForm.controls.libelle.value + " d’un montant total HT de " + this.bcForm.controls.ht.value.toFixed(2).replace(".", ",") + " €"
            + "\n\nPour être considérées comme recevables, les avoirs émis par le Prestataire devront obligatoirement comporter le n° de demande d'avoir."
            + "\n\nVous trouverez ci-dessous les directives et mentions obligatoires de facturation : "
            +(fournSite ? ("\n\n1 avoir par PDF et 1 avoir par mail à envoyer à l'adresse électronique suivante : \n" + fournSite.email) : "")
            + "\n\nMentions obligatoires à figurer sur l'avoir : votre Dénomination sociale, Adresse, Siret et N° tva intracommunautaire."
            + "\nNuméro de l'Avoir, Date de l'Avoir, N° de facture associés à l'Avoir, Numéro de demande d'Avoir, Devise (celle de l'Avoir), Montants : HT+TVA = TTC et taux de TVA"
            + "\n\nLibeller l'Avoir à l'entité et l'adresse de facturation spécifiées sur la commande."
            + "\n\nCordialement \nAssainissement et Maintenance France. ");
          }, 
          error => {
            this.formulaireForm.controls.email.setValue(fourn.mailInterloc);
            this.formulaireForm.controls.corpsMail.setValue("Madame, Monsieur,"
              + "\n\nVous trouverez en pièce jointe une demande d'avoir n° " + this.bcForm.controls.code.value + " concernant " + this.bcForm.controls.libelle.value + " d’un montant total HT de " + this.bcForm.controls.ht.value.toFixed(2).replace(".", ",") + " €"
              + "\n\nPour être considérées comme recevables, les avoirs émis par le Prestataire devront obligatoirement comporter le n° de demande d'avoir."
              + "\n\nVous trouverez ci-dessous les directives et mentions obligatoires de facturation : "
              + "\n\nMentions obligatoires à figurer sur l'avoir : votre Dénomination sociale, Adresse, Siret et N° tva intracommunautaire."
              + "\nNuméro de l'Avoir, Date de l'Avoir, N° de facture associés à l'Avoir, Numéro de demande d'Avoir, Devise (celle de l'Avoir), Montants : HT+TVA = TTC et taux de TVA"
              + "\n\nLibeller l'Avoir à l'entité et l'adresse de facturation spécifiées sur la commande."
              + "\n\nCordialement \nAssainissement et Maintenance France. ");
          });
        }else{
          // type BC Simple
          this.siteService.getFromCodeAndSociete(this.bcForm.controls.codeSiteLivraison.value, this.bcForm.controls.idSociete.value).subscribe((fournSite: SiteModel) => {        
            this.formulaireForm.controls.email.setValue(fourn.mailInterloc);
            this.formulaireForm.controls.corpsMail.setValue("Madame, Monsieur, \n\nPar le présent email, nous vous confirmons notre commande n° " + this.bcForm.controls.code.value + 
            " concernant " + this.bcForm.controls.libelle.value + " d’un montant total HT de " + this.bcForm.controls.ht.value.toFixed(2).replace(".", ",") + " €\n" +
            "Pour les fournisseurs assujettis à la réforme de facturation électronique, les factures doivent être adressés à l’identifiant d'adressage : " + this.siren + " aux formats Factur-X, UBL ou CII.\n" +
            " \n\nAfin de valider la commande, nous vous remercions de bien vouloir nous confirmer la disponibilité des articles ou services à la date de livraison souhaitée et livrée à : \n\n" + 
            fournSite.rSociale + " \n" + 
            fournSite.adr1 + " \n" +  
            ((fournSite.adr2 && fournSite.adr2.trim() !== '') ? (fournSite.adr2 + "\n") : '') +
            ((fournSite.adr3 && fournSite.adr3.trim() !== '') ? (fournSite.adr3 + "\n") : '')
  
            + "\nVous trouverez en pièce jointe le bon de commande au format PDF avec les informations requises au traitement de la commande. " 
            + "\n\nPour être considérées comme recevables, les factures émises par le Prestataire devront obligatoirement comporter le ou les numéros de Bon de Commande."
            + "\n\nVous trouverez ci-dessous les directives et mentions obligatoires de facturation : "
            +(fournSite ? ("\n\n1 facture par PDF et 1 facture par mail à envoyer à l'adresse électronique suivante : \n" + fournSite.email) : "")
            + "\n\nMentions obligatoires à figurer sur la facture : votre Dénomination sociale, Adresse, Siret et N° tva intracommunautaire."
            + "\nNuméro de facture, Date de facture, Numéro de commande, Désignation et décompte des produits et services rendus, Devise (celle de la commande), Montants : HT+TVA = TTC et taux de TVA"
            + "\n\nLibeller la facture à l'entité et l'adresse de facturation spécifiées sur la commande."
            + "\n\nEn cas de cession de facture, merci d'indiquer impérativement la mention \"cédée\" ainsi que les coordonnées bancaires du factor."
            + "\n\nCordialement \nAssainissement et Maintenance France. ");
          }, 
          error => {
            this.formulaireForm.controls.email.setValue(fourn.mailInterloc);
            this.formulaireForm.controls.corpsMail.setValue("Madame, Monsieur, \n\nPar le présent email, nous vous confirmons notre commande n° " + this.bcForm.controls.code.value + 
            " concernant " + this.bcForm.controls.libelle.value + " d’un montant total HT de " + this.bcForm.controls.ht.value.toFixed(2).replace(".", ",") + " €\n" +
            "Pour les fournisseurs assujettis à la réforme de facturation électronique, les factures doivent être adressés à l’identifiant d'adressage : " + this.siren + " aux formats Factur-X, UBL ou CII.\n" +
            " \n\nAfin de valider la commande, nous vous remercions de bien vouloir nous confirmer la disponibilité des articles ou services à la date de livraison souhaitée et livrée à : \n\n" +    
            "\n\nVous trouverez en pièce jointe le bon de commande au format PDF avec les informations requises au traitement de la commande. " +
            "\n\nPour être considérées comme recevables, les factures émises par le Prestataire devront obligatoirement comporter le ou les numéros de Bon de Commande."
            + "\n\nVous trouverez ci-dessous les directives et mentions obligatoires de facturation : "
            + "\n\nMentions obligatoires à figurer sur la facture : votre Dénomination sociale, Adresse, Siret et N° tva intracommunautaire."
            + "\nNuméro de facture, Date de facture, Numéro de commande, Désignation et décompte des produits et services rendus, Devise (celle de la commande), Montants : HT+TVA = TTC et taux de TVA"
            + "\n\nLibeller la facture à l'entité et l'adresse de facturation spécifiées sur la commande."
            + "\n\nEn cas de cession de facture, merci d'indiquer impérativement la mention \"cédée\" ainsi que les coordonnées bancaires du factor."
            + "\n\nCordialement \nAssainissement et Maintenance France. ");
          });
        }
      }
    });                  
  }

  submit(): void {
    if(this.formulaireForm.valid){
      let emailFournisseurModel = new EmailFournisseurDTO();
      emailFournisseurModel.token = this.sessionService.getRefreshToken().access_token;
      emailFournisseurModel.idBc = this.bcForm.get('id').value;;
      emailFournisseurModel.fournisseurEmail = this.formulaireForm.get('email').value;
      emailFournisseurModel.objetEmail = this.formulaireForm.get('objetMail').value;
      emailFournisseurModel.corpsEmail = this.formulaireForm.get('corpsMail').value;
      this.onModalCancel();
      if(this.bcForm.controls.type.value === DefinitionTypeBC.BCEnveloppe){
        this.pdfService.getBlobEnveloppe(this.bcForm.getRawValue()).subscribe(blob =>
          {
            const formData = new FormData();
            formData.append('document', new File([blob], "bon_commande"), 'bon_commande.pdf');
            formData.append('token', emailFournisseurModel.token);
            formData.append('idBc', emailFournisseurModel.idBc.toString());
            formData.append('fournisseurEmail', emailFournisseurModel.fournisseurEmail);
            formData.append('objetEmail', emailFournisseurModel.objetEmail);
            formData.append('corpsEmail',emailFournisseurModel.corpsEmail );
            this.bcService.sendEmailToFournisseur(formData).subscribe(msgId => {
              this.toastrService.success('Email envoyé au fournisseur : ' + emailFournisseurModel.fournisseurEmail, '', {disableTimeOut: true, tapToDismiss: true});
            });
          });
      }else{
        this.pdfService.getBlob(this.bcForm.getRawValue()).subscribe(blob =>
          {
            const formData = new FormData();
            formData.append('document', new File([blob], "bon_commande"), 'bon_commande.pdf');
            formData.append('token', emailFournisseurModel.token);
            formData.append('idBc', emailFournisseurModel.idBc.toString());
            formData.append('fournisseurEmail', emailFournisseurModel.fournisseurEmail);
            formData.append('objetEmail', emailFournisseurModel.objetEmail);
            formData.append('corpsEmail',emailFournisseurModel.corpsEmail );
            this.bcService.sendEmailToFournisseur(formData).subscribe(msgId => {
              this.toastrService.success('Email envoyé au fournisseur : ' + emailFournisseurModel.fournisseurEmail, '', {disableTimeOut: true, tapToDismiss: true});
            });
          });
      }
    }
  }

  onModalCancel(): void {
    this.dialogRef.close();
  }
}
